// src/utils/PrivateRoute.jsx
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  // const isAuthenticated = true; // fake login
  // const token = localStorage.getItem("token");
  const token = true;
  return token ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
